module.exports = __webpack_public_path__ + "static/7_layers-9f2c41703ee2294a1a092d9fc1e4a06a.png";